import { Suspense } from 'react';
import Main from './components/layouts/InAppLayout';
import AuthLayout from './components/layouts/AuthLayout';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { appRoutes, authRoutes } from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();

function App(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
          <Route element={<AuthLayout />}>
            {authRoutes?.map((item) => (
              <Route key={item.path} path={item.path} element={item.element} />
            ))}
          </Route>
          <Route element={<Main />}>
            {appRoutes?.map((item) => (
              <Route key={item.path} path={item.path} element={item.element} />
            ))}
          </Route>
          <Route path="*" element={<Main />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
